/* eslint-disable import/order */
import type { EntryPointComponent } from 'react-relay';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdGlobalSystemSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalSystemSettings.tsx';
import { gadgetDirectoryResource } from '@jira/router-resources__dashboard/src/dashboardConfigAndWRMResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { dashboardBackgroundScriptsLayout } from '@jira/platform__layouts-background-scripts-layout/src/index.tsx';
import { NORMAL_EARLY_ASSET_STRATEGY } from '@jira/platform__common-constants/src/ssr-early-assets.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { composeLayouts } from '@jira/platform__layouts-route-layout/src/GlobalComponent.tsx';
import { navigationSidebarGlobalResource } from '@jira/router-resources__navigation-sidebar-global/src/navigationSidebarGlobalResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { systemDashboardEditRoute } from '@jira/router-routes__dashboard-routes/src/systemDashboardEditRoute.tsx';
import {
	SystemDashboardEditPage,
	dashboardResources,
	LazySystemDashboardEdit,
	LazyForPaintBackgroundScripts,
	LazyForPaintConnectJsApi,
} from './ui/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

const systemDashboardEditPageEntryPoint = createPageEntryPoint({
	main: {
		root: JSResourceForUserVisible<EntryPointComponent<{}, {}, {}, {}>>(
			/* webpackChunkName: "async-system-dashboard-edit", jiraSpaEntry: "async-system-dashboard-edit" */ '@jira/spa-apps__dashboard-system-dashboard-edit/src/SystemDashboard.tsx',
			{ entryFsSsrLiftImportToModule: false },
		),
		getPreloadProps: () => ({}),
	},
});

export const systemDashboardEditRouteEntry: Route = createEntry(systemDashboardEditRoute, () => ({
	group: 'dashboard',

	// eslint-disable-next-line no-restricted-syntax
	component: fg('nike_entrypoint_migration_batch_1') ? undefined : SystemDashboardEditPage,

	entryPoint: () =>
		fg('nike_entrypoint_migration_batch_1') ? systemDashboardEditPageEntryPoint : undefined,
	layout: composeLayouts(globalSettingsLayout, dashboardBackgroundScriptsLayout),

	navigation: {
		sidebarId: SidebarIdGlobalSystemSettings,
		menuId: MenuIdSettings,
	},

	resources: [
		...getNavigationResources(),
		navigationSidebarGlobalResource,
		// IMPORTANT - SSR requires wrm resource must come first
		...dashboardResources(),
		gadgetDirectoryResource,
	],

	forPaint: [
		LazyAtlassianNavigation,
		LazySystemDashboardEdit,
		LazyForPaintBackgroundScripts,
		LazyForPaintConnectJsApi,
	],

	earlyAssets: NORMAL_EARLY_ASSET_STRATEGY,
	wrmMode: 'early',

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
